import $ from 'jquery';
import { getState } from '~src/state';
import { changeImageSrc } from '~src/utils';
import { getBase64ImageByUrl } from '~src/utils';
import { b64toBlob } from '~core';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
} from '~core/aiLoader';
// import { handleTabImagesAI } from '~src/sidebar/index'; // Now handled by onCompleteAttachment
import { stopMagicEraser } from './stopMagicEraser';
import { triggerStateChangedRequest } from '~core';

export const applyMagicEraser = async () => {
  // Start a simple loader for the saving phase
  startAiLoader(
    [
      { icon: '💾', text: 'Salvando la foto ritoccata...' },
      { icon: '✅', text: 'Applicando al progetto...' },
    ],
    '💾 Salvataggio in corso'
  );

  const image = window.magicEraserDrawingCanvas
    .getObjects()
    .find((o) => o.type === 'image');

  if (!image) {
    console.error('No modified image found on magic eraser canvas');
    stopAiLoader();
    return;
  }

  const modifiedImageUrl =
    image.getSrc() || image._element?.src || image._element?.currentSrc;

  if (!modifiedImageUrl) {
    console.error('No source URL for the modified image', {
      image,
      getSrc: image.getSrc(),
      elementSrc: image._element?.src,
      elementCurrentSrc: image._element?.currentSrc,
    });
    stopAiLoader();
    return;
  }

  const selection = getState('magicEraserTarget');

  const imageBase64 = await getBase64ImageByUrl(modifiedImageUrl);

  const blob = b64toBlob(imageBase64, 'image/jpeg');

  const attachmentsUploader = getState('uploader.allegati');
  const maskUrl = getState('magicEraserMaskUrl');

  attachmentsUploader.addFile({
    type: blob.type,
    data: blob,
    meta: {
      customAttachmentProps: {
        magicEraserRawImage: selection.getSrc(),
        magicEraserMask: maskUrl,
        isMagicEraser: true,
      },
    },
  });

  const responseUpload = await attachmentsUploader.upload();

  attachmentsUploader.cancelAll();

  const imageUrl = `${process.env.EDGE_RESIZER}${
    new URL(responseUpload.successful[0].uploadURL).pathname
  }`;

  // Check if the selection has a magic frame
  let magicFrame = selection._magicFrame;
  if (selection.type === 'MagicFrame') {
    magicFrame = selection;
  }

  if (magicFrame) {
    // If it's a magic frame, update the person image
    await magicFrame.updatePerson(imageUrl);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
  } else {
    // If it's a regular image, change the image source
    await changeImageSrc(selection, imageUrl);

    // Restore the original properties
    // expandedImage.set(currentProps);

    // Render the canvas to show the changes
    window.canvas.renderAll();
  }

  $('#editor-menu-run-magic-eraser').attr('disabled', true);
  // $('#editor-menu-apply-magic-eraser').attr('disabled', true); // Button deprecated

  stopAiLoader();
  triggerStateChangedRequest();
  stopMagicEraser();

  // Show success message (updated for direct application)
  showAiSuccessMessage(
    'Correzione Applicata',
    'La foto è stata corretta e applicata al progetto!'
  );

  // Note: handleTabImagesAI() is called from onCompleteAttachment for credit refresh
};
